import { Header } from '@/components/Header';
import { CSRFTokenProvider, StageProvider } from '@/pages/contextProvider';
import { Stage } from '@eventbrite/webapp-constants';
import { PropsWithChildren } from 'react';
import styles from './Layout.module.scss';
import { LeftPane } from './LeftPane';
import { RightPane } from './RightPane';

interface LayoutProps {
  csrfToken: string;
  stage: Stage;
  pageType: string;
  emailId?: string;
}

export const Layout: React.FC<PropsWithChildren<LayoutProps>> = ({
  children,
  stage,
  csrfToken,
  pageType,
  emailId,
}) => {
  return (
    <StageProvider stage={stage}>
      <CSRFTokenProvider csrfToken={csrfToken}>
        <div className={styles.pageWrapper}>
          <Header />
          <div className={styles.layoutContentDiv}>
            <LeftPane pageType={pageType} emailId={emailId}>
              {children}
            </LeftPane>
            <RightPane />
          </div>
        </div>
      </CSRFTokenProvider>
    </StageProvider>
  );
};
